<template>
  <div>
    <div id="Chart16" style="width: 100%; height: 340px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    myEcharts16() {
      var myChart16 = this.$echarts.init(document.getElementById("Chart16"));
      //配置图表
      var option16 = {
        tooltip: {
          trigger: "axis",
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 25,
          top: 30,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "2022-01-02",
            "2022-01-03",
            "2022-01-04",
            "2022-01-05",
            "2022-01-06",
            "2022-01-07",
            "2022-01-08",
          ],
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          offset: 24,
          axisLabel: {
            formatter: function (value) {
              if (value == "2022-01-02") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 140,
                align: "right",
              },
              b: {
                width: 140,
                align: "left",
              },
            },
          },
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              textStyle: {
              },
              formatter: function (value) {
                return value + '%';
              },
            },
            position: "left",
            min:'6.90',
            max:'8.70',
          },
        ],
        series: [
          {
            name: "占流通A股(左)",
            type: "line",
            smooth: true,
            symbol: "circle",
            showSymbol: false,
            color: "#fcad2a",
            data: [7.40,7.20,7.30,7.40,7.80,7.46,7.56],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(252,173,42,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(252,173,42,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          {
            name: "股价(右)",
            type: "line",
            smooth: true,
            symbol: "circle",
            showSymbol: false,
            color: "#539cff",
            data: [7.91, 8.23, 7.96, 7.77, 7.50, 7.31, 7.27],
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        ],
      };
      myChart16.setOption(option16);
    },
  },
  mounted() {
    this.myEcharts16();
  },
};
</script>

<style scoped>
</style>